import { IUserDetails } from './user-details';
export interface  Iuser {
    userId?: number;
    username?: string;
    firstName: string;
    lastName: string;
    email: string;
    mobileNo: string;
    userDetailsJson : IUserDetails,
    roles : string[],
    status? : number;
    passwordHash: string;

}

export class User implements Iuser{
    userId?: number; 
    username?: string;   
    firstName: string;
    lastName: string;
    email: string;
    mobileNo: string;
    userDetailsJson: IUserDetails;
    roles: string[];
    status? : number;
    passwordHash: string;
    constructor() {
        this.userId = 0;
        this.username = '';
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.mobileNo = '';
        this.roles = [];
        this.status = 1;
        this.passwordHash = '';
    }
    
}
interface AfterViewInit {
    ngAfterViewInit(): void
  } 